<template>
  <v-dialog
    :value="value"
    persistent
    max-width="400"
    @input="changeVisibility"
  >
    <v-card>
      <v-card-title class="headline">
        Quote limit exceeded
      </v-card-title>
      <v-card-text>
        <div v-html="config.partnerQuoteLimitData" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <qz-btn
          color="primary"
          text
          data-test="quote-limit-modal-confirm"
          @click="changeVisibility(false)"
        >
          OK
        </qz-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'quote-limit-exceed-popup',
  inject: ['config'],
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    changeVisibility (v) {
      this.$emit('input', v);
    },
  },
};
</script>
